export default {
  stock: {
    GoodsNo: '货号',
    ProductName: '商品名称',
    StockBasicUnitQuantity: '原有库存',
    UnitPrice: '单价',
    Amount: '金额',
    nextQuantity30: '未来30天库存',
    nextQuantity60: '未来60天库存',
    nextQuantity90: '未来90天库存',
    Quantity: '现有库存',

    stockInNo: '入库单编号',
    stockOutNo: '出库单编号',
    documentMaker: '制单人',
    Passed: '已通过',
    notPass: '未通过',
    ToAudit: '待审核',
    stockInStatus: '入库状态',
    stockOutStatus: '出库状态',
    stockInDetail: '入库单详情',
    stockOutDetail: '出库单详情'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/ims/stock.js